import parse from 'html-react-parser'

export const findRichTextLink = (html: string): any => {
  if (html?.length <= 0) return null

  const parsedHtml = parse(html)

  if (parsedHtml instanceof Array) {
    const links = findAnchorElements(parsedHtml, []).map((t: any) => {
      return {
        url: t.props.href,
        target: t.props.target === '_blank' ? '_blank' : undefined,
        type:
          t.props.target && t.props.target === '_blank'
            ? 'EXTERNAL'
            : undefined,
      }
    })
    if (links.length > 1 || links.length == 0) return null
    return links.find((x) => x)
  }

  return null
}

const findAnchorElements = (
  parsedHtml: JSX.Element[],
  currentLinks: JSX.Element[]
): any => {
  if (parsedHtml instanceof Array) {
    parsedHtml.forEach((t: JSX.Element) => {
      if (t?.type === 'a') {
        currentLinks.push(t)
      }

      if (t.props?.children) {
        if (t.props.children instanceof Array) {
          findAnchorElements(t.props.children, currentLinks)
        } else {
          findAnchorElements([t.props.children], currentLinks)
        }
      }
    })
  }
  return currentLinks.flat()
}
